import { testimonials } from "@/mocks/testimonials";
import { useState } from "react";

export default function TestimonialSection() {
  const [visibleCount, setVisibleCount] = useState(3);

  const visibleTestimonials = testimonials.slice(0, visibleCount);
  const hasMore = visibleCount < testimonials.length;

  return (
    <section className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-2.5 h-2.5 rounded-full bg-accent-500"></div>
            <span className="text-xs font-semibold text-foreground-600 tracking-wider uppercase">User Reviews</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Trusted by Thousands<br />of Smart Shoppers
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg">
            Real feedback from real users who transformed their agent shopping experience with our spreadsheet systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visibleTestimonials.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-xl p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? "ri-star-fill text-accent-500" : "ri-star-line text-foreground-300"} w-4 h-4 flex items-center justify-center`}
                  ></i>
                ))}
              </div>
              <h4 className="text-sm font-bold text-foreground-900 mb-2">{t.title}</h4>
              <p className="text-xs text-foreground-600 leading-relaxed mb-4">{t.content}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {hasMore && (
          <div className="text-center mt-10">
            <button
              onClick={() => setVisibleCount(testimonials.length)}
              className="px-6 py-3 border-2 border-primary-500 text-primary-600 rounded-md text-sm font-semibold hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Reviews
            </button>
          </div>
        )}
      </div>
    </section>
  );
}